var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wscn-http404-container"},[_c('div',{staticClass:"pic-404"},[_c('img',{staticClass:"pic-404-bg",attrs:{"src":require("@/assets/404_images/404.png"),"alt":"404"}}),_c('el-button',{staticClass:"bullshit__return-home",attrs:{"type":"primary"},on:{"click":_vm.routerback}},[_vm._v("返回")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }